
export const SET_GROUP = "SET_GROUP";
export const CHANGE_STATUS = "CHANGE_STATUS";
export const UPDATE_GROUP = 'UPDATE_GROUP';
export const DELETE_GROUP = 'DELETE_GROUP'